import { render, staticRenderFns } from "./ModalEdit.vue?vue&type=template&id=5a8f9f2e&scoped=true&"
import script from "./ModalEdit.vue?vue&type=script&lang=ts&"
export * from "./ModalEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ModalEdit.vue?vue&type=style&index=0&id=5a8f9f2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8f9f2e",
  null
  
)

export default component.exports